module.exports = __webpack_public_path__ + "img/4Y5.66fe88f2.png";